// 홈 진입 시 푸시 권한 안내 팝업을 노출할 대상 userId (지정 사용자 한정).
// 이 저장소는 보통 user.isInsider 로 내부 사용자를 분기하지만, 본 안내는 특정 계정만을
// 위한 한정 노출이므로 예외적으로 명시적 userId 목록을 사용한다.
export const HOME_PUSH_PROMPT_TARGET_USER_IDS = [128377, 129686];

// "한번이상 물어봤다" 여부는 앱 재시작(=새 로드) 후에도 유지되어야 한다.
// deviceAtom.pushNotificationStatus 는 매 로드마다 undefined 로 초기화되므로
// 추적 용도로는 부적합하여, localStorage 로 계정별 노출 이력을 별도 저장한다.
const askedStorageKey = (userId: number | string) =>
  `homePushPromptAsked_${userId}`;

export const hasAskedHomePushPrompt = (userId: number | string): boolean =>
  localStorage.getItem(askedStorageKey(userId)) === "true";

export const markHomePushPromptAsked = (userId: number | string): void => {
  localStorage.setItem(askedStorageKey(userId), "true");
};

// userId 는 타입상 number 지만 서버 응답/로그인 경로에서 문자열로 들어오는 경우가 있어
// (코드베이스 전반이 Number(`${result.userId}`) 로 강제 변환) 비교 전에 숫자로 강제 변환한다.
export function isHomePushPromptTargetUser(
  userId: number | string | undefined
): boolean {
  if (userId === undefined || userId === null || userId === "") return false;
  const numericUserId = Number(userId);
  return (
    !Number.isNaN(numericUserId) &&
    HOME_PUSH_PROMPT_TARGET_USER_IDS.includes(numericUserId)
  );
}

// 홈 진입 시 푸시 권한 안내 팝업을 노출해야 하는지 판단한다.
// 노출 조건: 앱 웹뷰 & 환자 & 대상 userId & 아직 물어본 적 없음 &
//            푸시 권한 상태가 "허용됨"이 아니면서 이미 확인된 값일 것.
// (undefined = 아직 상태 미확인 → 조회 응답을 기다리며 노출하지 않음)
export function shouldShowHomePushPrompt(params: {
  isInappWebview: boolean | undefined;
  isCoach: boolean;
  userId: number | string | undefined;
  pushNotificationStatus: string | undefined;
  hasAsked: boolean;
}): boolean {
  const { isInappWebview, isCoach, userId, pushNotificationStatus, hasAsked } =
    params;
  if (!isInappWebview || isCoach) return false;
  if (!isHomePushPromptTargetUser(userId)) return false;
  if (hasAsked) return false;
  if (
    pushNotificationStatus === undefined ||
    pushNotificationStatus === "granted"
  )
    return false;
  return true;
}
